export interface FAQ {
  id: number;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 1,
    question: '如何注册金沙娱乐账号？',
    answer: '注册金沙娱乐账号非常简单。点击页面右上角的"立即注册"按钮，填写您的手机号码或邮箱地址，设置登录密码，完成短信或邮箱验证即可成功注册。整个注册过程不超过2分钟。',
  },
  {
    id: 2,
    question: '金沙娱乐支持哪些支付方式？',
    answer: '金沙娱乐支持多种安全便捷的支付方式，包括银行卡转账、微信支付、支付宝、USDT加密货币等。所有支付通道均采用银行级加密技术，确保您的资金安全。存款即时到账，提款快速处理。',
  },
  {
    id: 3,
    question: '如何联系金沙娱乐客服？',
    answer: '金沙娱乐提供7×24小时全天候客服支持。您可以通过在线客服聊天、官方客服邮箱、VIP专属客服热线等多种方式联系我们。我们的专业客服团队将第一时间为您解答问题。',
  },
  {
    id: 4,
    question: '金沙娱乐的游戏是否公平？',
    answer: '金沙娱乐所有游戏均采用国际认证的随机数生成器（RNG），确保每局游戏结果完全随机且不可预测。真人荷官游戏全程直播，玩家可实时观看荷官的每一个操作。平台定期接受第三方独立机构的公平性审计。',
  },
  {
    id: 5,
    question: '如何参与平台的优惠活动？',
    answer: '登录金沙娱乐账号后，您可以在"优惠活动"页面查看所有进行中的活动。每个活动都有详细的参与规则说明。部分活动自动参与，部分需要点击"立即参与"按钮或满足特定条件。活动奖励会自动发放到您的账户。',
  },
  {
    id: 6,
    question: '提款需要多长时间？',
    answer: '金沙娱乐致力于提供最快的提款服务。一般情况下，提款申请提交后30分钟内即可处理完成。大额提款可能需要额外的身份验证流程，以确保资金安全。具体到账时间取决于您选择的支付方式。',
  },
  {
    id: 7,
    question: '忘记密码怎么办？',
    answer: '如果您忘记了登录密码，请点击登录页面的"忘记密码"链接，输入您注册时使用的手机号码或邮箱地址，系统将发送验证码给您。验证通过后即可重新设置密码。',
  },
  {
    id: 8,
    question: '一个人可以注册多个账号吗？',
    answer: '金沙娱乐实行一人一号制度，每位用户只能注册一个账号。多账号注册和使用属于违规行为，平台有权对违规账号采取限制措施。我们建议您妥善保管自己的账号信息，不要与他人共享。',
  },
];